module.exports = __webpack_public_path__ + "static/media/clue0201.1ac19a98.jpg";